import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Center = ({ children, testid }) => (
  <section className="min-h-[80vh] flex items-center justify-center pt-32 px-5 text-center" data-testid={testid}><div className="max-w-lg">{children}</div></section>
);

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) return setState("error");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); refresh(); return; }
        if (["expired", "failed"].includes(data.status)) return setState("error");
      } catch { /* retry */ }
      if (++tries < 15) timer = setTimeout(poll, 2000); else setState("pending");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refresh]);
  return (
    <Center testid="payment-success-page">
      {state === "checking" && <><Loader2 className="mx-auto animate-spin text-[#D4AF37]" size={44} /><h1 className="h2 mt-6">Confirming your payment...</h1></>}
      {state === "paid" && <><CheckCircle2 className="mx-auto text-[#D4AF37]" size={52} /><h1 className="h2 mt-6" data-testid="payment-confirmed">Payment confirmed.</h1><p className="lead mt-4">Thank you for partnering with The Transformed Mind Experience.</p><Link to="/dashboard" className="btn-gold mt-8" data-testid="payment-dashboard-btn">Go to dashboard</Link></>}
      {state === "pending" && <><h1 className="h2">Payment is processing.</h1><p className="lead mt-4">This can take a moment. Your dashboard will update automatically.</p><Link to="/dashboard" className="btn-gold mt-8">Go to dashboard</Link></>}
      {state === "error" && <><XCircle className="mx-auto text-red-400" size={52} /><h1 className="h2 mt-6">We couldn't confirm this payment.</h1><Link to="/partnership" className="btn-outline mt-8">Back to partnership</Link></>}
    </Center>
  );
}

export const PaymentCancel = () => (
  <Center testid="payment-cancel-page">
    <h1 className="h2">Checkout canceled.</h1>
    <p className="lead mt-4">No charge was made. You can come back anytime.</p>
    <Link to="/partnership" className="btn-gold mt-8">View partnership</Link>
  </Center>
);

export const NotFound = () => (
  <Center testid="not-found-page">
    <p className="font-serif text-8xl font-light text-white tracking-tighter">404</p>
    <h1 className="h2 mt-4">Page not found.</h1>
    <Link to="/" className="btn-gold mt-8">Return home</Link>
  </Center>
);
